export default __webpack_public_path__ + "static/media/registration.ba7d53db.jpg";